import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import capitalize from 'lodash/capitalize';

import { Link } from '@bibliocommons/base-links';

import { extractDomain } from 'app/helpers/url';
import { fieldValueShape } from 'app/shapes/bibPage';
import ContentLabel from '../ContentLabel';
import ValuePart from '../ValuePart';

import './FieldValue.scss';

export default class FieldValue extends React.PureComponent {
  renderContributorRelationship() {
    const relationship = this.props.value.get('relationship') || Immutable.Map();
    const content = relationship
      .get('values', Immutable.List())
      .map(capitalize)
      .join(', ');

    return content && <div className="part-contributor-relationship">{content}</div>;
  }

  renderURL() {
    const url = this.props.value.get('sourceURI');

    if (url) {
      const source = extractDomain(url);
      return (
        <div className="part-source">
          <Link href={url} dataKey="source-url-link">
            <FormattedMessage id="view_on_source" values={{ source }} />
          </Link>
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <div className="cp-bib-field-value">
        <ContentLabel fieldValue={this.props.value} />

        <div className="main-content">
          <ValuePart
            className="part-primary"
            compact={this.props.compact}
            part={this.props.value.get('primary')}
            handleClick={this.props.handleClick}
          />
          <ValuePart
            className="part-secondary"
            compact={this.props.compact}
            part={this.props.value.get('secondary')}
            handleClick={this.props.handleClick}
          />
        </div>

        <div className="other-content">
          <ValuePart
            className="part-contributor"
            compact={this.props.compact}
            part={this.props.value.get('contributor')}
            handleClick={this.props.handleClick}
          />
          {this.renderContributorRelationship()}
          {this.renderURL()}
        </div>
      </div>
    );
  }
}

FieldValue.propTypes = {
  value: fieldValueShape.isRequired,
  compact: PropTypes.bool,
  handleClick: PropTypes.func
};
